import angular from 'angular';

import RowManagerRowModule from './row-manager-row/row-manager-row';

const ComponentsModule = angular.module('control-room.commons.form.components.row-manager.components', [
    RowManagerRowModule.name,
]);

export default ComponentsModule;
